/**
 * WordPress dependencies.
 */
import { Fragment, useEffect } from '@wordpress/element';
import { Panel, PanelBody, Button, PanelRow, SnackbarList, DropdownMenu } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { applyFilters, addFilter } from '@wordpress/hooks';
import { useDispatch, useSelect } from '@wordpress/data';
import apiFetch from '@wordpress/api-fetch';
import { store as noticesStore } from '@wordpress/notices';

/**
 * Exteranl dependencies.
 */
import { merge, filter } from 'lodash';

/**
 * Inner dependencies.
 */
import '../../../extensions/store/settings';
import styling from '../../inline-css';
import './colors';
import './typography';

const copySiteOptions = ( obj ) => {
	function handler( event ) {
		event.clipboardData.setData( 'text/plain', JSON.stringify( obj ) );
		event.preventDefault();
		document.removeEventListener( 'copy', handler, true );
	}

	document.addEventListener( 'copy', handler, true );
	document.execCommand( 'copy' );
};

const DesignTab = ( props ) => {
	const { styleId, gStyle, changeSiteOptions, siteOptions } = props;
	useEffect( ( ) => {
		if ( styleId && gStyle ) {
			apiFetch( {
				path: `/wp/v2/global-styles/${ styleId }`,
				method: 'get',
			} )
				.then( ( res ) => {
					changeSiteOptions( merge(
						siteOptions,
						{
							coreSettings: {
								styles: merge( gStyle.styles, res.styles ),
							},
						},
					) );
				} );
		}
	}, [ styleId, gStyle ] );
	const { createSuccessNotice } = useDispatch( noticesStore );
	const { removeNotice } = useDispatch( noticesStore );
	const notices = useSelect(
		( select ) => select( noticesStore ).getNotices(),
		[]
	);
	const snackbarNotices = filter( notices, {
		type: 'snackbar',
	} );
	return <>
		<Fragment key="gutenify-admin-settings-panel">
			<Panel className="gutenify-setting-panel-toolbar-area">
				<PanelRow>
					<div></div>
					<div><DropdownMenu
						icon={ 'ellipsis' }
						label="Select a direction"
						controls={ [
							{
								title: 'Copy core Options',
								icon: 'admin-page',
								onClick: () => {
									copySiteOptions( props.siteOptions.coreSettings );
									createSuccessNotice( __( 'Core Settings copied.' ), {
										type: 'snackbar',
									} );
								},
							},
							{
								title: 'Copy Gutenify Options',
								icon: 'admin-page',
								onClick: () => {
									copySiteOptions( props.siteOptions.settings );
									createSuccessNotice( __( 'Gutenify Settings copied.' ), {
										type: 'snackbar',
									} );
								},
							},
						] }
					/></div>
				</PanelRow>
			</Panel>
			<Panel header={ __( '' ) }>
				{ applyFilters( 'gutenify-admin-settings-design-panel', [], props ) }
			</Panel>
			<Panel className="gutenify-setting-panel-toolbar-area">
				<PanelRow>
					<Button variant="secondary" onClick={ () => {
						if ( ! window.confirm( 'Are you sure to reset design settings?' ) ) {
							return false;
						}
						apiFetch( {
							path: `/wp/v2/global-styles/${ styleId }`,
							method: 'POST',
							data: {
								styles: {},
							},
						} )
							.then( ( ) => {
								changeSiteOptions( merge(
									siteOptions,
									{
										coreSettings: {
											styles: {},
										},
									},
								) );
							} )
							.catch( ( err ) => {
								console.log( err );
							} );

						apiFetch( {
							path: `/gutenify/v1/update_site_options`,
							method: 'POST',
							data: {
								styles: {},
							},
						} )
							.then( ( ) => {
								changeSiteOptions( merge(
									siteOptions,
									{
										settings: {
											styles: {},
										},
									},
								) );
							} )
							.catch( ( err ) => {
								console.log( err );
							} );

						apiFetch( {
							path: `/gutenify/v1/update_global_styles`,
							method: 'POST',
							data: {
								css: '',
								adminCss: '',
							},
						} )
							.then( ( res ) => {
								console.log( res );
							} )
							.catch( ( err ) => {
								console.log( err );
							} );

						location.reload();
					} }>Reset</Button>
					<div>
						<Button variant="primary" onClick={ () => {
							const coreSettings = siteOptions.coreSettings;
							const settings = siteOptions.settings;
							apiFetch( {
								path: `/wp/v2/global-styles/${ styleId }`,
								method: 'POST',
								data: coreSettings,
							} )
								.then( ( res ) => {
									// console.log( res );
								} )
								.catch( ( err ) => {
									// console.log( err );
								} );

							apiFetch( {
								path: `/gutenify/v1/update_site_options`,
								method: 'POST',
								data: settings,
							} )
								.then( ( res ) => {
									console.log( res );
								} )
								.catch( ( err ) => {
									// console.log( err );
								} );

							const coreStyles = siteOptions.coreSettings.styles;
							const gutenifyStyles = siteOptions.settings.styles;

							const css = styling( coreStyles, gutenifyStyles );
							const adminCss = styling( coreStyles, gutenifyStyles, true );
							apiFetch( {
								path: `/gutenify/v1/update_global_styles`,
								method: 'POST',
								data: {
									css,
									adminCss,
								},
							} )
								.then( ( res ) => {

								} )
								.catch( ( err ) => {
									console.log( err );
								} );
							createSuccessNotice( __( 'Settings saved.' ), {
								type: 'snackbar',
							} );
						} }>Save</Button>

					</div>
				</PanelRow>
			</Panel>
		</Fragment>
		<SnackbarList
			notices={ snackbarNotices }
			className="edit-navigation-notices__snackbar-list"
			onRemove={ removeNotice }
		/>
	</>;
};

export default DesignTab;
